import { EventEmitter, Injectable } from "@angular/core";
import { TrvMapExtension } from "../trv-map-extension/trv-map-extension";
import { Subject } from "rxjs";
import {NvdbNavigationService} from "@app/service/nvdb-navigation.service";

@Injectable({
    providedIn: "root",
})
export class TrvMapExtensionService {
    public trvMapExtension!: TrvMapExtension;
    public initEmitter: EventEmitter<void> = new EventEmitter<void>();

    constructor() {}

    public setTrvMapExtension(trvMapExtension: TrvMapExtension) {
        this.trvMapExtension = trvMapExtension;
    }
}
